module.exports = __webpack_public_path__ + "img/ic-arrow-left-circle.9d42061e.svg";